import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { Grid, Switch, makeStyles } from '@material-ui/core';
import Order from '../../Order/Order';
import OrderColorDisplay from '../../Order/OrderColorDisplay';
import React, { useState, useEffect } from 'react';
import BackForwardButton from '../../Shared/BackForwardButton';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { xsValue } from '../../../Config/constants'
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { productionOrderStates as state } from '../../../Config/productionOrderStates'
import ScissorStateComponent from '../../Workstation/ScissorStateComponent';
import { machine } from '../../../Config/constants';
import { connect } from 'react-redux';
import SwitchRawMaterialDialog from '../../Order/SwitchRawMaterialDialog';
import { scissorTypes } from '../../../Config/scissorStates';
import TableStateComponent from '../../Workstation/TableStateComponent';

export const OrderOverviewPage = (props) => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [workstations, setWorkstations] = useState([])
    const [searchString, setSearchString] = useState("")
    const [productionOrders, setProductionOrders] = useState([])
    const [noOrdersFound, setNoOrdersFound] = useState(false)
    const [reload, setReload] = useState(false)
    const [switchRawMaterialDialogOpen, setSwitchRawMaterialDialogOpen] = useState(false)
    const [rawMaterialSwitchOrderId, setRawMaterialSwitchOrderId] = useState(false)
    const [rawMaterialSwitchOrderReference, setRawMaterialSwitchOrderReference] = useState(false)
    const [rawMaterialSwitchDefaultSilo, setRawMaterialSwitchDefaultSilo] = useState(false)
    const [colorDisplay, setColorDisplay] = useState(false)
    const [openColorDisplayNumber, setOpenColorDisplayNumber] = useState(0)

    const openSwitchRawMaterialDialog = (orderLineId, reference, defaultSilo) => {
        setRawMaterialSwitchOrderId(orderLineId);
        setRawMaterialSwitchOrderReference(reference);
        setRawMaterialSwitchDefaultSilo(defaultSilo);
        setSwitchRawMaterialDialogOpen(true);
    }

    const closeSwitchRawMaterialDialog = () => {
        setSwitchRawMaterialDialogOpen(false)
    }

    const switchRawMaterial = (orderLineId, switchPercentage, hasReplacementMaterial = true) => {
        console.log("switch percentage: " + switchPercentage)
        closeSwitchRawMaterialDialog()
        dataService.switchRawMaterialForOrder(orderLineId, switchPercentage, hasReplacementMaterial).then(() => {
            setReload(true)
        }).catch((error) => { toast.error(error, { position: "top-center" }) })
    }

    const toggleColorDisplay = () => {
        setColorDisplay(!colorDisplay)
    }

    const handleOpenColorDisplay = (orderId) => {
        if (openColorDisplayNumber === orderId) {
            setOpenColorDisplayNumber(0)
        }
        else {
            setOpenColorDisplayNumber(orderId)
        }
    }


    useEffect(() => {
        setReload(false);

        if (searchString) {
            dataService.getProductionOrdersBySearchText(searchString).then(orders => {
                if (orders.length === 0) {
                    setNoOrdersFound(true)
                }
                else {
                    setNoOrdersFound(false)
                    setProductionOrders(orders)
                }

            }).catch((error) => { toast.error(error, { position: "top-center" }) })
        }
        else {
            setNoOrdersFound(false)
            dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {
                setProductionOrders(orders)
            }).catch((error) => { toast.error(error, { position: "top-center" }) })
        }

        dataService.getMachinesByMachineType(machine).then(stations => {
            setWorkstations(stations)
        }).catch((error) => { toast.error(error, { position: "top-center" }) })

        return () => { }

    }, [searchString, props.workstation.selectedWorkstation, reload]);

    let activeProductionOrders = <React.Fragment></React.Fragment>
    let doneProductionOrders = <React.Fragment></React.Fragment>

    if (props.workstation.activeWorkstations[0]) {
        if (productionOrders) {
            if (colorDisplay) {
                activeProductionOrders = productionOrders.filter(x => x.productionOrderStatus !== state.DONE && x.productionOrderStatus !== state.STOPPED).sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><OrderColorDisplay key={order.id} actions={props.actions} openSwitchRawMaterialDialog={openSwitchRawMaterialDialog} handleOpenColorDisplay={handleOpenColorDisplay} openColorDisplayNumber={openColorDisplayNumber} productionOrder={order} setReload={setReload} {...props}></OrderColorDisplay></Grid>));
                doneProductionOrders = productionOrders.filter(x => x.productionOrderStatus === state.DONE || x.productionOrderStatus === state.STOPPED).sort((a, b) => new Date(a.startedOnPlanned) - new Date(b.startedOnPlanned)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><OrderColorDisplay key={order.id} actions={props.actions} openSwitchRawMaterialDialog={openSwitchRawMaterialDialog} handleOpenColorDisplay={handleOpenColorDisplay} openColorDisplayNumber={openColorDisplayNumber} productionOrder={order} {...props}></OrderColorDisplay></Grid>));
            }
            else {
                activeProductionOrders = productionOrders.filter(x => x.productionOrderStatus !== state.DONE && x.productionOrderStatus !== state.STOPPED).sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} openSwitchRawMaterialDialog={openSwitchRawMaterialDialog} productionOrder={order} setReload={setReload} {...props}></Order></Grid>));
                doneProductionOrders = productionOrders.filter(x => x.productionOrderStatus === state.DONE || x.productionOrderStatus === state.STOPPED).sort((a, b) => new Date(a.startedOnPlanned) - new Date(b.startedOnPlanned)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} openSwitchRawMaterialDialog={openSwitchRawMaterialDialog} handleOpenColorDisplay={handleOpenColorDisplay} openColorDisplayNumber={openColorDisplayNumber} productionOrder={order} {...props}></Order></Grid>));
            }
        }
        if (searchString && !noOrdersFound) {
            if (colorDisplay) {
                activeProductionOrders = productionOrders.sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><OrderColorDisplay key={order.id} actions={props.actions} openSwitchRawMaterialDialog={openSwitchRawMaterialDialog} handleOpenColorDisplay={handleOpenColorDisplay} openColorDisplayNumber={openColorDisplayNumber} productionOrder={order} setReload={setReload} {...props}></OrderColorDisplay></Grid>));
                doneProductionOrders = activeProductionOrders
            }
            else {
                activeProductionOrders = productionOrders.sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} openSwitchRawMaterialDialog={openSwitchRawMaterialDialog} productionOrder={order} setReload={setReload} {...props}></Order></Grid>));
                doneProductionOrders = activeProductionOrders
            }
        }
        if (noOrdersFound) {
            doneProductionOrders = <div className={classes.noOrdersFound}>{t("No orders found for the search criteria entered")}</div>
            activeProductionOrders = doneProductionOrders
        }
    }

    function searchOrder(e) {
        setSearchString(e.target.value)
    }

    const handleChange = (event, newValue) => {
        if (newValue === 1 && colorDisplay) {
            setColorDisplay(false)
        }
        setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    function refreshOrders() {
        dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {
            if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {
                setProductionOrders(orders)
            }

        }).catch((error) => { toast.error(error, { position: "top-center" }) })
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return <div className={classes.backGround}>
        <div className={classes.spacer80}>
            <div className={classes.left}>
                <NavLink className={classes.navButton} to={`/`}>
                    <BackForwardButton direction={'Back'} textOverride={t("Back to workstations")}></BackForwardButton>
                </NavLink>
                <div className={classes.title}>{t('Production queue')}</div>
            </div>
            <div className={classes.right}>
                <div className={classes.scissorStatusContainer}>
                    {workstations.length && props.workstation.selectedWorkstation > 0 && props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.TABLE)
                        ?
                        <div className={classes.scissor}>
                            <TableStateComponent size={"M"} machineNumber={workstations.find(x => x.id === props.workstation.selectedWorkstation).code.match(/\d/g).join("")} tableStatus={props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.TABLE)}></TableStateComponent>
                        </div>
                        :
                        <React.Fragment></React.Fragment>
                    }

                    {workstations.length && props.workstation.selectedWorkstation > 0 && props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
                        ?
                        <div className={classes.scissor}>
                            <ScissorStateComponent size={"M"} machineNumber={workstations.find(x => x.id === props.workstation.selectedWorkstation).code.match(/\d/g).join("")} selectedWorkstation={props.workstation.selectedWorkstation} upper></ScissorStateComponent>
                        </div>
                        :
                        <React.Fragment></React.Fragment>}
                    {workstations.length && props.workstation.selectedWorkstation > 0 && props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)
                        ?
                        <div className={classes.scissor}>
                            <ScissorStateComponent size={"M"} machineNumber={workstations.find(x => x.id === props.workstation.selectedWorkstation).code.match(/\d/g).join("")} selectedWorkstation={props.workstation.selectedWorkstation} lower></ScissorStateComponent>
                        </div>
                        :
                        <React.Fragment></React.Fragment>}
                </div>
                <div className={classes.searchContainer}>
                    <TextField
                        className={classes.search}
                        variant="outlined"
                        size="small"
                        onChange={(e) => searchOrder(e)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <img className={classes.eye} src={process.env.PUBLIC_URL + '/img/search.svg'} alt={""}></img>
                                </InputAdornment>
                            ),
                        }}>
                    </TextField>
                    <div className={classes.searchButtons}>
                        <button className={classes.refreshButton} onClick={() => refreshOrders()}>
                            <AutorenewIcon className={classes.refreshIcon}></AutorenewIcon>
                            <div className={classes.refreshText}>{t("REFRESH")}</div>
                        </button>
                        {value === 0 ?
                            <div className={classes.switchMode}>
                                <Switch className={classes.switchButton} color='primary' style={{ color: FlagstoneTheme.palette.primary.main }} onChange={toggleColorDisplay} />
                                <div className={classes.switchText}>{t("COLOR DISPLAY")}</div>
                            </div>
                            :
                            <React.Fragment></React.Fragment>}
                    </div>
                </div>
            </div>
        </div>
        <AppBar position="static" className={classes.appBar}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label={t("ACTIVE")} {...a11yProps(0)} className={clsx({ [classes.activeTab]: value === 0, [classes.notActiveTab]: value !== 0 })} />
                <Tab label={t("DONE")} {...a11yProps(1)} className={clsx({ [classes.activeTab]: value === 1, [classes.notActiveTab]: value !== 1 })} />
            </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
            <Grid container spacing={3} className={classes.grid}>
                {activeProductionOrders}
            </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
            <Grid container spacing={3} className={classes.grid}>
                {doneProductionOrders}
            </Grid>
        </TabPanel>
        {switchRawMaterialDialogOpen && <SwitchRawMaterialDialog dialogOpen={switchRawMaterialDialogOpen} rawMaterialSwitchDefaultSilo={rawMaterialSwitchDefaultSilo} rawMaterialSwitchOrderId={rawMaterialSwitchOrderId} rawMaterialSwitchOrderReference={rawMaterialSwitchOrderReference} switchRawMaterial={switchRawMaterial} closeDialog={closeSwitchRawMaterialDialog}></SwitchRawMaterialDialog>}
    </div>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'
    },
    backGround: {
        paddingRight: "1%",
        marginTop: "40px",
    },

    gridmargin: {
        minWidth: "450px",
        paddingRight: "0.8% !important",
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column'
    },
    navButton: {
        textDecoration: "none",
        border: "none",
        outline: "none",
        marginLeft: "18px"
    },
    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        paddingLeft: "5px",
        marginLeft: "20px"
    },
    date: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        marginTop: "4px",
        paddingLeft: "7px",
        marginBottom: "3px",
        marginLeft: "20px"
    },
    search: {
        width: "100%",
        backgroundColor: "white",
        marginTop: "5px",
    },
    left: {
        width: "45%",
        height: "70px",
        float: 'left'
    },
    right: {
        width: "55%",
        height: "90px",
        float: 'right',
        textAlign: "right",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"
        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    refreshButton: {
        height: "40px",
        border: "none",
        color: "white",
        outline: "1px solid " + FlagstoneTheme.palette.primary.main,
        backgroundColor: FlagstoneTheme.palette.primary.main,
        borderRadius: "5px",
        marginTop: "10px",
        cursor: "pointer",
        zIndex: "999",
        paddingRight: "10px",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        '&:hover': {
            backgroundColor: "white",
            color: FlagstoneTheme.palette.primary.main,

        },
    },
    switchButton: {
        cursor: "pointer",
        zIndex: "999",
        color: FlagstoneTheme.palette.primary.main,
    },
    switchMode: {
        height: "40px",
        border: "none",
        outline: "none",
        zIndex: "999",
        paddingRight: "5px",
        width: "100%",
        display: "flex",
        textWrap: "nowrap",
    },
    refreshIcon: {
        float: "left",
    },
    refreshText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        // color: "white",
        float: "left",
        cursor: "pointer"
    },
    switchText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        float: "left",
        paddingTop: "13px",

    },
    noOrdersFound: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        color: "#8D8D8D",
        padding: "10px",
        marginLeft: "10px"

    },
    scissorStatusContainer: {
        width: "50%",
        maxWidth: "350px",
        float: "left",
        paddingTop: "5px",
        marginRight: "15px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: 'column',
    },
    searchContainer: {
        float: "right",
        display: "flex",
        flexDirection: 'column',
    },
    searchButtons: {
        width: "100%",
        display: "flex",
        flexDirection: 'column'
    },
    upperScissor: {
        width: "90%"

    },
    lowerScissor: {
        width: "90%"
    }
});


function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        workstationState: state.workstationState
    }
}

export default connect(mapStateToProps)(OrderOverviewPage)